// Communication — 4 KPI cards (Appels / Emails / SMS / WhatsApp).
import { useEffect, useState } from "react";
import { Phone, Mail, MessageCircle, MessageSquare, Loader2 } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => {
  const t = localStorage.getItem("session_token");
  return t ? { Authorization: `Bearer ${t}` } : {};
};

function Kpi({ icon: Icon, label, value, color }) {
  return (
    <div className="rounded-xl p-3 flex items-center gap-3"
      style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
      <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: `${color}20`, color }}>
        <Icon className="w-5 h-5" />
      </div>
      <div>
        <p className="text-xs" style={{ color: "var(--oh-text-muted)" }}>{label}</p>
        <p className="text-xl font-bold" style={{ color: "var(--oh-text)" }}>{value}</p>
      </div>
    </div>
  );
}

export default function CommunicationStatsWidget() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const calls = await axios.get(`${API}/api/calls?limit=100`, { headers: auth() });
        const all = calls.data.calls || [];
        let sms = { sent: 0, total: 0 }, email = { sent: 0, total: 0 };
        try {
          const [s, e] = await Promise.all([
            axios.get(`${API}/api/communication/stats?channel=sms`, { headers: auth() }),
            axios.get(`${API}/api/communication/stats?channel=email`, { headers: auth() }),
          ]);
          sms = s.data; email = e.data;
        } catch {}
        if (!cancelled) setStats({ calls: all.length, sms: sms.sent || 0, email: email.sent || 0 });
      } finally { if (!cancelled) setLoading(false); }
    })();
    return () => { cancelled = true; };
  }, []);

  if (loading) return <div className="rounded-xl p-5 flex items-center justify-center"
    style={{ background: "var(--oh-bg-elevated)", border: "1px solid var(--oh-border)" }}>
    <Loader2 className="w-5 h-5 animate-spin" style={{ color: "var(--oh-text-muted)" }} /></div>;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="communication-stats-widget">
      <Kpi icon={Phone} label="Appels" value={stats.calls} color="var(--oh-stat-blue-text)" />
      <Kpi icon={Mail} label="Emails envoyés" value={stats.email} color="#8b5cf6" />
      <Kpi icon={MessageCircle} label="SMS envoyés" value={stats.sms} color="var(--oh-stat-amber-text)" />
      <Kpi icon={MessageSquare} label="WhatsApp" value="—" color="var(--oh-text-muted)" />
    </div>
  );
}
